import { useEffect } from "react"

import { Modal, Skeleton } from "@/atoms"
import { LoadErrorEmptyTable } from "@/molecules/EmptyTable"

import type { AgentPlatformConnectionBase } from "@/api/useDeployments.types"
import type { ConnectionSettingsStateProps } from "../CloudConnectionSettings.types"

// The connection's settings once its platform's connections are read: loading
// and a failed read show in the modal; a connection gone (disconnected
// elsewhere) closes it, as its row is about to leave the list
export const ConnectionSettingsState = <C extends AgentPlatformConnectionBase>(
  props: ConnectionSettingsStateProps<C>
) => {
  const { connections, connectionId, isLoading, isLoadError, onClose } = props
  const connection = connections.find(
    (candidate) => candidate.connectionId === connectionId
  )
  const gone = !isLoading && !isLoadError && !connection

  useEffect(() => {
    if (gone) onClose()
  }, [gone, onClose])

  if (connection) return props.children(connection)

  if (gone) return null

  return (
    <Modal open footer={null} onCancel={onClose}>
      {isLoadError ? (
        <LoadErrorEmptyTable onRetry={props.refetch} />
      ) : (
        <Skeleton active paragraph={{ rows: 6 }} />
      )}
    </Modal>
  )
}
